import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const RadioField = ({
  className = '',
  inputClassName = '',
  meta = {},
  errorMessage = '',
  options = [],
  input = {}
}) => {
  const { error, submitFailed } = meta;
  const radioFieldClassNames = classNames('RadioField custom-control custom-radio', className);

  return (
    <div>
      {
        options.map((option) => {
          return (
            <div key={option.id} className={`${radioFieldClassNames} ${option.className}`}>
              <input
                {...input}
                type="radio"
                id={(option.id).replace(/\s/g, '-')}
                className={classNames('custom-control-input', inputClassName)}
                checked={input.value === option.value}
                defaultChecked={input.value === option.value}
                value={option.value}
              />
              <label
                className="custom-control-label"
                htmlFor={(option.id).replace(/\s/g, '-')}
              >
                {option.label}
              </label>
              {
                option.component && (
                  <div className={option.componentClass}>
                    { option.component }
                  </div>
                )
              }
              {
                option.customComponent && (
                  option.customComponent
                )
              }
            </div>
          );
        })
      }
      {
        (error && submitFailed) && (
          <p className="error text-danger text-small">
            {errorMessage || error}
          </p>
        )
      }
    </div>
  );
};

RadioField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  input: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.string
};

export default RadioField;
